import { PaginatorInfo } from "./generic.dto"

export interface PaymentSetup {
  id: number
  companyId: number
  providerRequestId: string | null
  surname: string | null
  otherNames: string | null
  email: string | null
  phoneNumber: string | null
  companyName: string | null
  tradeName: string | null
  alias: string | null
  tier: string | null
  country: string | null
  typeOfCompany: string | null
  companyCategories: string | null
  countryMerchantCategoryId: string | null
  companyRegistrationNumber: string | null
  vatRegistrationNumber: string | null
  taxIdentificationNumber: string | null
  dateOfIncorporation: Date | null
  dateOfCommencement: Date | null
  companyLogo: string | null
  status: PaymentSetupStatus
  createdAt: Date
  modifiedAt: Date | null
  completedAt: Date | null
  providerMerchantUniqueId: string | null
}

export const enum PaymentSetupStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCESSFUL = "SUCCESSFUL",
  REJECTED = "REJECTED",
  DRAFT = "DRAFT"
}

export interface SetupCompanyDirector{
 id: string;
 paymentSetupId: number;
 lastName: string | null;
 otherNames: string | null;
 email: string | null;
 phoneNumber: string | null;
 identityCode: string | null;
 identity: string | null;
 verificationId: string | null;
 createdAt: Date;
 modifiedAt: Date | null;
}

export interface SetupContact{
 id: number;
 paymentSetupId: number;
 name: string | null;
 email: string | null;
 phone: string | null;
 createdAt: Date;
 modifiedAt: Date | null;
}

export interface SetupDocument{
    id: number;
    paymentSetupId: number;
    code: string | null;
    fileUrl: string | null;
    createdAt: Date;
    modifiedAt: Date | null;
}

export interface SetupOfficeAddress{
 id: number;
 paymentSetupId: number;
 officeAddress: string | null;
 officeOwnership: string | null;
 officeCity: string | null;
 officeRegion: string | null;
 officeDistrict: string | null;
 officePhone: string | null;
 officeMobile: string | null;
 officeGpsAddress: string | null;
 createdAt: Date;
 modifiedAt: Date | null;
}

export interface SetupPaymentProductType{
 id: number;
 paymentSetupId: number;
 code: string | null;
 name: string | null;
 description: string | null;
 paymentInstitutionId: string | null;
 paymentInstitutionTypeId: string | null;
 paymentInstitutionBranchName: string | null;
 paymentInstitutionAccountNumber: string | null;
 paymentInstitutionAccountName: string | null;
 receiveStatement: boolean | null;
 createdAt: Date;
 modifiedAt: Date | null;
}

export class AddProductToMerchantRequestCreateDto {
  tier!: string;
  products!: PaymentSetupProduct[];
}

export class UpdateProductToMerchantRequestCreateDto {
  tier!: string;
  products!: PaymentSetupProduct[];
}

export class PaymentSetupDataDto {
  companyName?: string;
  tradeName?: string;
  alias?: string;
  tier?: string;
  country?: string;
  typeOfCompany?: string;
  companyCategories?: string;
  countryMerchantCategoryId?: string;
  companyRegistrationNumber?: string;
  vatRegistrationNumber?: string;
  taxIdentificationNumber?: string;
  dateOfIncorporation?: Date;
  dateOfCommencement?: Date;
  companyLogo?: string;
  documents?: PaymentSetupDocument[];
  officeAddress?: PaymentSetupOfficeAddress[];
  contacts?: PaymentSetupContact[];
  companyDirectors?: PaymentSetupCompanyDirector[];
  products?: PaymentSetupProduct[];
  surname?: string;
  otherNames?: string;
  email?: string;
  phoneNumber?: string;
}

export interface PaymentSetupDto extends PaymentSetup {
  documents?: SetupDocument[]
  officeAddress?: SetupOfficeAddress[]
  contacts?: SetupContact[]
  companyDirectors?: SetupCompanyDirector[]
  products?: SetupPaymentProductType[]
}

export interface PaymentSetupPaginator extends PaginatorInfo<PaymentSetupDto> {
}

export class QueryMerchantRequestDto {
  companyId?: number;
  status?: string;
  sourceId?: string;
  companyName?: string;
  tradeName?: string;
  alias?: string;
  taxIdentificationNumber?: string;
  sectionId?: string;
  start?: Date;
  end?: Date;
  limit?: number;
  page?: number;
}

export class QueryDraftPaymentSetupDto {
  page = 1;
  limit?: number;
  orderBy: PaymentSetupOrderBy = PaymentSetupOrderBy.CREATED_AT_DESC;
}

export class SearchMerchantRequestDto {
  merchantId?: string;
  productCode?: string;
  status?: string;
  sourceId?: string;
  limit?: number;
  page?: number;
}


export class CreatePaymentSetupDto {
  companyName!: string;
  tradeName?: string;
  alias?: string;
  tier!: string;
  country!: string;
  typeOfCompany?: string;
  companyCategories!: string;
  countryMerchantCategoryId?: string;
  companyRegistrationNumber?: string;
  vatRegistrationNumber?: string;
  taxIdentificationNumber?: string;
  dateOfIncorporation?: Date;
  dateOfCommencement?: Date;
  companyLogo!: string;
  documents!: PaymentSetupDocument[];
  officeAddress?: PaymentSetupOfficeAddress[];
  contacts?: PaymentSetupContact[];
  companyDirectors!: PaymentSetupCompanyDirector[];
  products?: PaymentSetupProduct[];
  surname!: string;
  otherNames!: string;
  email?: string;
  phoneNumber?: string;
}

export interface DraftPaymentSetupRequestDto extends UpdatePaymentSetupDto {
  id?: number;
}

export class OnboardMerchantDto {
  companyName!: string;
  tradeName?: string;
  alias?: string;
  tier!: string;
  country!: string;
  typeOfCompany?: string;
  companyCategories!: string;
  countryMerchantCategoryId?: string;
  companyRegistrationNumber?: string;
  vatRegistrationNumber?: string;
  taxIdentificationNumber?: string;
  dateOfIncorporation?: Date;
  dateOfCommencement?: Date;
  companyLogo!: string;
  documents!: MerchantOnboardingDocument[];
  officeAddress?: PaymentSetupOfficeAddress[];
  contacts?: PaymentSetupContact[];
  companyDirectors!: MerchantOnboardingCompanyDirector[];
  products?: PaymentSetupProduct[];
  surname!: string;
  otherNames!: string;
  email?: string;
  phoneNumber?: string;
}

export class UpdateOnboardedMerchantDto {
  companyName?: string;
  tradeName?: string;
  alias?: string;
  tier?: string;
  country?: string;
  typeOfCompany?: string;
  companyCategories?: string;
  countryMerchantCategoryId?: string;
  companyRegistrationNumber?: string;
  vatRegistrationNumber?: string;
  taxIdentificationNumber?: string;
  dateOfIncorporation?: Date;
  dateOfCommencement?: Date;
  companyLogo?: string;
  documents?: MerchantOnboardingDocument[];
  officeAddress?: PaymentSetupOfficeAddress[];
  contacts?: PaymentSetupContact[];
  companyDirectors?: MerchantOnboardingCompanyDirector[];
  products?: PaymentSetupProduct[];
  surname?: string;
  otherNames?: string;
  email?: string;
  phoneNumber?: string;
}

export interface UpdatePaymentSetupDto extends PaymentSetupDataDto {
  providerRequestId?: string;
  providerMerchantUniqueId?: string;
  status?: PaymentSetupStatus;
}


type PaymentSetupDocument = {
  /** Present when updating an existing record */
  id?: number | string;
  code?: string;
  file?: string
}

export type MerchantOnboardingDocument = {
  /** Present when updating an existing record */
  id?: number | string;
  code?: string;
  file?: string;
}

export enum TierOneDocumentCode { 
  ghana_card = 'ghana_card', 
  operation_license = 'operation_license', 
  product_service_description = 'product_service_description',
  business_registration = 'business_registration'
}
export enum TierTwoDocumentCode {  
  ghana_card = 'ghana_card', 
  operation_license = 'operation_license', 
  product_service_description = 'product_service_description',
  tin_number = 'tin_number',
  business_registration = 'business_registration'
}
export enum TierThreeDocumentCode { 
  ghana_card = 'ghana_card', 
  operation_license = 'operation_license', 
  product_service_description = 'product_service_description',
  tin_number = 'tin_number',
  business_registration = 'business_registration',
  form_3a = 'form_3a', 
  directors_identification = 'directors_identification', 
  ownership_structure = 'ownership_structure', 
  regulator_license = 'regulator_license', 
  product_description = 'product_description', 
  aml_fraud_policy = 'aml_fraud_policy', 
  data_protection_certificate = 'data_protection_certificate', 
  vulnerability_test_report = 'vulnerability_test_report', 
  due_diligence ='due_diligence', 
  bank_statements = 'bank_statements', 
  audited_financial_statements = 'audited_financial_statements', 
  shareholding_structure_additional = 'shareholding_structure_additional',
  source_of_funds_explanation = 'source_of_funds_explanation'
} 

type PaymentSetupOfficeAddress = {
  /** Present when updating an existing record */
  id?: number | string;
  officeAddress: string;
  officeOwnership?: string;
  officeCity?: string;
  officeRegion?: string;
  officeDistrict?: string;
  officePhone?: string;
  officeMobile?: string;
  officeGpsAddress?: string;
}

type PaymentSetupContact = {
  /** Present when updating an existing record */
  id?: number | string;
  name?: string;
  email?: string;
  phone?: string;
}

type PaymentSetupCompanyDirector = {
  /** Present when updating an existing record */
  id?: number | string;
  lastName: string;
  otherNames: string;
  email?: string;
  phoneNumber?: string;
  identityCode?: IdentityCode;
  identity?: string;
  verificationId?: string;
}

export type MerchantOnboardingCompanyDirector = {
  /** Present when updating an existing record */
  id?: number | string;
  lastName: string;
  otherNames: string;
  email?: string;
  phoneNumber?: string;
  identityCode?: IdentityCode;
  identity?: string;
  verificationId?: string;
}

export enum IdentityCode {
  ghana_card = 'ghana_card',
  passport = 'passport'
}

export type PaymentSetupProduct = {
  /** Present when updating an existing record */
  id?: number | string;
  code: string;
  name: string;
  description: string;
  destinationDetails: {
    destinationId: string;
    destinationTypeId: string;
    destinationBranchName: string;
    destinationAccountNumber: string;
    destinationAccountName: string;
    receiveStatement: BoolEnum;
  }
}

export enum BoolEnum {
  Y = 'Y',
  N = 'N'
}

export class CountPaymentSetupDto {
  status?: PaymentSetupStatus;
}

export class QueryPaymentSetupDto extends CountPaymentSetupDto {
  page? = 1;
  limit?: number;
  orderBy: PaymentSetupOrderBy = PaymentSetupOrderBy.CREATED_AT_DESC;
}

export enum PaymentSetupOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
}